/**
 * Ids shared by the launcher and the lazily loaded panel (ticket 21.4).
 *
 * A module of its own so `AssistantWidget` can point `aria-controls` at the
 * window without importing `AssistantPanel`, which would pull the whole panel
 * into the main bundle.
 */
export const ASSISTANT_WINDOW_ID = "assistant-window";
